import { useState } from "react";
import { GrSearch } from "react-icons/gr";
import { locationIds } from "../../../../core/enums";
import { capitalize } from "../../../../utils/capitalize";
import Loader from "../../../Atoms/Loader";
import { FormatDateRange } from "../../MultiCardModal/components/DateRangeSearch";
import { formatGuests } from "../../MultiCardModal/components/GuestSearch";
import { formatTags } from "../../MultiCardModal/components/TagSearch";
import s from "../SearchBar.module.scss";
import SearchBarElement from "../components/SearchBarElement";
import { SearchBarProps } from "../types";
import SearchModal from "./SearchModal";

export default function SmallSearchBar({ loading, ...props }: SearchBarProps) {
  const [openModal, setOpenModal] = useState(false);

  return (
    <div className={s.SearchBar}>
      <SearchBarElement
        label={<SmallSearchLabel {...props} />}
        value={<SmallSearchSummary {...props} />}
        variant="mobile"
        startAdornment={
          <div
            style={{ position: "relative", left: -8, top: 4, marginRight: 8 }}
          >
            <GrSearch size={24} />
          </div>
        }
        endAdornment={
          loading ? (
            <div style={{ position: "absolute", right: 4 }}>
              <Loader color="#f33f3a" />
            </div>
          ) : (
            <></>
          )
        }
        onClick={() => setOpenModal(true)}
      />
      <SearchModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        {...props}
      />
    </div>
  );
}

type SmallSearchLabelProps = Pick<
  SearchBarProps,
  "locationId" | "from" | "until" | "timeRanges"
>;

function SmallSearchLabel({
  from,
  until,
  locationId,
  timeRanges,
}: SmallSearchLabelProps) {
  const locationLabel = capitalize(
    Object.entries(locationIds).find(([_, id]) => locationId === id)?.[0] ?? ""
  );

  return (
    <div
      style={{
        display: "flex",
        gap: "0.25rem",
        alignItems: "center",
      }}
    >
      {locationLabel}
      {locationLabel && <span>·</span>}
      <div>{FormatDateRange({ from, until, timeRanges, gap: 4 })}</div>
    </div>
  );
}
type SmallSearchSummaryProps = Pick<
  SearchBarProps,
  "numGuests" | "tags" | "tagOptions"
>;
function SmallSearchSummary({
  numGuests,
  tagOptions,
  tags,
}: SmallSearchSummaryProps) {
  return (
    <div
      style={{
        display: "flex",
        gap: "0.25rem",
        alignItems: "center",
      }}
    >
      <div>{formatGuests(numGuests)}</div>·
      <div
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {formatTags({ tags, tagOptions })}
      </div>
    </div>
  );
}
